export const LinearGradientOrange = ["#2980B9", "#34495E", "#2C3E5039"];

export const theme = {
    primary: LinearGradientOrange[0],
    secondary: LinearGradientOrange[1],
    overlay: "rgba(44, 62, 80, 0.22)",
    gradient: `linear-gradient(145deg, ${LinearGradientOrange[0]} 0%, ${LinearGradientOrange[1]} 58%, rgba(44, 62, 80, 0.22) 100%)`,
    gradientButton: `linear-gradient(135deg, ${LinearGradientOrange[0]} 0%, ${LinearGradientOrange[1]} 100%)`,
};
